// Add to context is a context mechanism used for clean and tidy code
//, that is managable in later application states.
// This can be extended to create a more complex context mechanism
// This can be extended to create no-reload websites
// This can be extended to create vanilla JavaScript web applications

class Context {
    constructor({target}, callbacks) {
        this.target = document.querySelectorAll(target);
        this.callbacks = callbacks;
        this.init();
    }

    init = () => {
       
        this.callbacks.forEach((callback, index) => {
            if (typeof callback === 'function') {
                console.log(`Running callback ${index}`);
                callback({ target: this.target });
            }
        });
    }
}

export { Context as default }